import React, { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
// Update document meta tags for The Yarn Bazaar
document.title = "The Yarn Bazaar — India's #1 B2B Yarn Marketplace";
// Meta description
const metaDescription = document.querySelector('meta[name="description"]') || document.createElement('meta');
metaDescription.setAttribute('name', 'description');
metaDescription.setAttribute('content', "The Yarn Bazaar is India's leading B2B yarn marketplace connecting mills, traders, and exporters. Backed by Shark Tank India Season 1. Mumbai, India.");
if (!document.querySelector('meta[name="description"]')) document.head.appendChild(metaDescription);
// Keywords
const metaKeywords = document.createElement('meta');
metaKeywords.setAttribute('name', 'keywords');
metaKeywords.setAttribute('content', 'yarn marketplace, B2B yarn, yarn trading India, cotton yarn, yarn suppliers, textile marketplace, yarn bazaar, shark tank india');
document.head.appendChild(metaKeywords);
// Open Graph
const ogTags = [{
  property: 'og:title',
  content: "The Yarn Bazaar — India's #1 B2B Yarn Marketplace"
}, {
  property: 'og:description',
  content: 'Connecting mills, traders, and exporters across India and beyond. Backed by Shark Tank India Season 1.'
}, {
  property: 'og:type',
  content: 'website'
}, {
  property: 'og:url',
  content: 'https://theyarnbazaar.com'
}, {
  property: 'og:image',
  content: 'https://cdn.magicpatterns.com/uploads/gPkoxER8MRU5GSVk7bdedN/LogoBlack.fdf2fa00.svg'
}, {
  property: 'og:site_name',
  content: 'The Yarn Bazaar'
}, {
  property: 'og:locale',
  content: 'en_IN'
}];
ogTags.forEach(({
  property,
  content
}) => {
  const tag = document.createElement('meta');
  tag.setAttribute('property', property);
  tag.setAttribute('content', content);
  document.head.appendChild(tag);
});
// Twitter Card
const twitterTags = [{
  name: 'twitter:card',
  content: 'summary_large_image'
}, {
  name: 'twitter:title',
  content: "The Yarn Bazaar — India's #1 B2B Yarn Marketplace"
}, {
  name: 'twitter:description',
  content: 'Connecting mills, traders, and exporters across India and beyond. Backed by Shark Tank India Season 1.'
}, {
  name: 'twitter:image',
  content: 'https://cdn.magicpatterns.com/uploads/gPkoxER8MRU5GSVk7bdedN/LogoBlack.fdf2fa00.svg'
}];
twitterTags.forEach(({
  name,
  content
}) => {
  const tag = document.createElement('meta');
  tag.setAttribute('name', name);
  tag.setAttribute('content', content);
  document.head.appendChild(tag);
});
// Canonical URL
const canonical = document.createElement('link');
canonical.setAttribute('rel', 'canonical');
canonical.setAttribute('href', 'https://theyarnbazaar.com');
document.head.appendChild(canonical);
// Favicon — using the TYB logo as favicon via SVG data URI
const favicon = document.querySelector('link[rel="icon"]') || document.createElement('link');
favicon.setAttribute('rel', 'icon');
favicon.setAttribute('type', 'image/svg+xml');
favicon.setAttribute('href', 'https://cdn.magicpatterns.com/uploads/gPkoxER8MRU5GSVk7bdedN/LogoBlack.fdf2fa00.svg');
if (!document.querySelector('link[rel="icon"]')) document.head.appendChild(favicon);
// Apple touch icon
const appleTouchIcon = document.createElement('link');
appleTouchIcon.setAttribute('rel', 'apple-touch-icon');
appleTouchIcon.setAttribute('href', 'https://cdn.magicpatterns.com/uploads/gPkoxER8MRU5GSVk7bdedN/LogoBlack.fdf2fa00.svg');
document.head.appendChild(appleTouchIcon);
// Theme color (matches brand orange)
const themeColor = document.createElement('meta');
themeColor.setAttribute('name', 'theme-color');
themeColor.setAttribute('content', '#E8500A');
document.head.appendChild(themeColor);
// Robots
const robots = document.createElement('meta');
robots.setAttribute('name', 'robots');
robots.setAttribute('content', 'index, follow');
document.head.appendChild(robots);
// Author
const author = document.createElement('meta');
author.setAttribute('name', 'author');
author.setAttribute('content', 'Filosha Infotech Private Limited');
document.head.appendChild(author);
// Viewport (ensure it's set correctly)
let viewport = document.querySelector('meta[name="viewport"]');
if (!viewport) {
  viewport = document.createElement('meta');
  viewport.setAttribute('name', 'viewport');
  viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
  document.head.appendChild(viewport);
}
// Structured data (JSON-LD)
const structuredData = document.createElement('script');
structuredData.setAttribute('type', 'application/ld+json');
structuredData.textContent = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'The Yarn Bazaar',
  legalName: 'Filosha Infotech Private Limited',
  url: 'https://theyarnbazaar.com',
  logo: 'https://cdn.magicpatterns.com/uploads/gPkoxER8MRU5GSVk7bdedN/LogoBlack.fdf2fa00.svg',
  description: "India's leading B2B yarn marketplace connecting mills, traders, and exporters.",
  foundingDate: '2019',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'A-3104 DB Woods Opp Laxchandi Heights, Gokuldham Goregaon (East)',
    addressLocality: 'Mumbai',
    addressRegion: 'Maharashtra',
    postalCode: '400063',
    addressCountry: 'IN'
  },
  sameAs: ['https://in.linkedin.com/company/theyarnbazaar', 'https://www.instagram.com/theyarnbazaar/', 'https://www.facebook.com/theyarnbazaar/']
});
document.head.appendChild(structuredData);
const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = createRoot(container);
root.render(<React.StrictMode data-id="element-629">
    <App data-id="element-630" />
  </React.StrictMode>);